var AbstractViewModel = require("./AbstractViewModel")
var QueueModel = require("../models/QueueModel")
var AbstractWS = require("../ws/AbstractWS")

function ExternalResourcesViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's observable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.queue = ko.observable(null);
  self.resourceCount = ko.observable(0);


	/**
	 * Decrements the resourceCount by 1
	 *
	 * @method decrementCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return {Boolean} true
	 */
  self.decrementCount = function (data, evt) {
    var newCount = self.resourceCount() - 1;

    if (newCount < 1) {
      newCount = 1;
    }

    self.resourceCount(newCount);
  };


	/**
	 * Increments the resourceCount by 1
	 *
	 * @method incrementCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return {Boolean} true
	 */
  self.incrementCount = function (data, evt) {
    var newCount = self.resourceCount() + 1;

    if (newCount > 99) {
      newCount = 99;
    }

    self.resourceCount(newCount);
  };


	/**
	 * Returns the VM to it's default state
	 *
	 * @method reset
	 * @return none
	 */
  self.reset = function () {
    self.queue(null);
    self.resourceCount(0);
  };


	/**
	 * Pushes the new resource count to the API service for the current queue
	 *
	 * @method updateResourceCount
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return none
	 */
  self.updateResourceCount = function (data, evt) {
    var queue = self.queue();
    if (queue) {
      var ws = new AbstractWS(self);

      ws.method('POST');
      ws.name = 'ExternalResourceUpdater';
      ws.serviceURL = ko.computed(function () {

        return '/qless/api/v1/employee/queue/' + queue.id + '/externalResources';
      });
      ws.addParam('count', self.resourceCount());

      ws.processData = function (data) {
        // Call the superclass method to perform any core actions
        AbstractWS.prototype.processData.call(ws, data);

        self.reset();
      }

      ws.doRequest();

      self.parent.toggleExternalResources();
    }
    else {
      self.conlog('No queue. Can\'t update');
    }
  };


	/**
	 * Ensures only numbers are entered into the resource count input
	 *
	 * @method validateInput
	 * @param {Mixed} data
	 * @param {MouseEvent} evt
	 * @return none
	 */
  self.validateInput = function (data, evt) {
    if (!self.parent.isNumericInput(evt)) {
      evt.preventDefault();
      return false;
    }

    return true;
  };


	/**
	 * Watches for the queue change and updates the resourceCount observable
	 *
	 * @method queue.subscribe
	 * @param {QueueModel} data
	 * @return none
	 */
  self.queue.subscribe(function (data) {
    if (data && data instanceof QueueModel) {
      if (data.externalResourceCount) {
        self.resourceCount(Number(data.externalResourceCount));
      }
    }
  });


  // Expose the object as it's own API
  return self;
};

ExternalResourcesViewModel.prototype = AbstractViewModel.prototype;
ExternalResourcesViewModel.prototype.constructor = ExternalResourcesViewModel;

module.exports = ExternalResourcesViewModel
